import { HALApiService } from '../hal-api.service'
import { createItemsData } from '../../helpers/request-helpers'
import { Service } from './base-service'

export const pickingTasksService = new Service('/storage/tasks/task', HALApiService, createItemsData)
